var PersianDateFilter = function ($filter) {
    return function (input) {

        if (input == null) {
            return "";
        }

        var inputDate = new Date(input);
        var tehranTimeZone = convertTZ(inputDate, 'Asia/Tehran')
        var date = new JDate(tehranTimeZone);
        if (date != undefined) {

            //var month = date.getMonth();
            //var day = date.getDay();
            //if (month < 10) {
            //    month = "0" + month;
            //}
            //if (day < 10) {
            //    day = "0" + day;
            //}
            //
            //return date.getFullYear()+"/"+month+"/"+day;

            return date.format('YYYY/MM/DD');
        } else {
            return input;
        }
        ;
    }
}

function convertTZ(date, tzString) {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));
}

var FullPersianDateFilter = function ($filter) {
    return function (input) {

        if (input == null) {
            return "";
        }

        var inputDate = new Date(input);
        var tehranTimeZone = convertTZ(inputDate, 'Asia/Tehran')
        var date = new JDate(tehranTimeZone);
        if (date != undefined) {

            //var month = date.getMonth();
            //var day = date.getDay();
            //if (month < 10) {
            //    month = "0" + month;
            //}
            //if (day < 10) {
            //    day = "0" + day;
            //}
            //
            //return date.getFullYear()+"/"+month+"/"+day;

            //return date.format('ddd DD MMM YYYY   ');
            return date.format('ddd DD/MMM/YYYY ');
        } else {
            return input;
        }
        ;
    }
}
var PersianTimeFilter = function ($filter) {
    return function (input) {

            if (input == null) {
                return "";
            }
            var inputDate = new moment(input);
//            var tehranTime    = inputDate.tz("Asia/Tehran");
            var date = inputDate.format("HH:mm") ;

            return date;

    };
}
angular.module('tikonApp').filter('toPersianDate', PersianDateFilter);
angular.module('tikonApp').filter('toFullPersianDate', FullPersianDateFilter);
angular.module('tikonApp').filter('toPersianTime', PersianTimeFilter);
PersianDateFilter.$inject = ['$filter'];
PersianTimeFilter.$inject = ['$filter'];
FullPersianDateFilter.$inject = ['$filter'];
